import Vue, { createApp } from 'vue'
import App from './App.vue'
import { createI18n} from "vue-i18n";
import en from './i18n/en.json'
import pt from './i18n/pt.json'
import es from './i18n/es.json'
import cz from './i18n/cz.json'
import router from './Router'
import mitt from 'mitt'

import * as Sentry from "@sentry/vue";
import { browserTracingIntegration } from "@sentry/vue"


const emitter = mitt()

import {store, key} from './vuex/store'

import './sass/main.scss'

const app = createApp(App)

export const languages = {
    pt: pt,
    en: en,
    es: es,
    cz: cz
}

export const i18n = createI18n({
    locale:'pt',
    fallbackLocale: 'en',
    messages: Object.assign(languages)
})

Sentry.init({
  app,
  dsn: "https://93d13e41d2e7378b4dedac5e66064dcc@o4508415983222784.ingest.de.sentry.io/4510120521957456",
  integrations: [
    Sentry.consoleLoggingIntegration({ levels: ["log", "warn", "error"] }),
    browserTracingIntegration({
      router: router
    })
  ],
  tracesSampleRate: 1.0,
  sendDefaultPii: true,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  enableLogs: true,
  environment: process.env.ENV,
});

const originalConsoleError = console.error.bind(console)
console.error = (...args) => {
  // Enviar para Sentry
  Sentry.captureMessage(
    args.map(a => (a instanceof Error ? a.stack : JSON.stringify(a))).join(' | '),
    'error' // nível
  )
  // Continuar a mostrar na consola
  originalConsoleError(...args)
}

app.use(store, key)
app.use(i18n)
app.use(router)
app.provide('emitter', emitter)
app.mount('#app')

